module.exports = __webpack_public_path__ + "026405605de01b8923a9afdaccec0305.png";